(() => {
  const burger = document.querySelector('.hd__burger');
  const drawer = document.getElementById('Drawer');
  if (burger && drawer) {
    burger.addEventListener('click', () => {
      const open = drawer.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open);
      burger.textContent = open ? 'Close' : 'Menu';
      document.body.style.overflow = open ? 'hidden' : '';
    });
  }

  const peek = document.querySelector('.arc__peek');
  const peekImg = peek && peek.querySelector('img');
  document.querySelectorAll('.arc__row[data-img]').forEach((row) => {
    row.addEventListener('mouseenter', () => {
      if (!peek || document.querySelector('.arc--grid')) return;
      peekImg.src = row.dataset.img;
      peek.classList.add('is-on');
    });
    row.addEventListener('mouseleave', () => peek && peek.classList.remove('is-on'));
    row.addEventListener('mousemove', (e) => {
      if (!peek) return;
      const x = Math.min(e.clientX + 24, window.innerWidth - 236);
      const y = Math.min(e.clientY - 60, window.innerHeight - 310);
      peek.style.left = x + 'px';
      peek.style.top = Math.max(y, 60) + 'px';
    });
  });

  const filters = document.querySelectorAll('.arc__filters button');
  filters.forEach((btn) => {
    btn.addEventListener('click', () => {
      filters.forEach((b) => b.setAttribute('aria-pressed', 'false'));
      btn.setAttribute('aria-pressed', 'true');
      const key = btn.dataset.filter;
      const groups = document.querySelectorAll('.arc__group');
      groups.forEach((g) => {
        // Showcased pieces stay out of the grid under All; they're already shown above it.
        g.hidden = key === 'all' ? g.hasAttribute('data-pinned') : g.dataset.group !== key;
      });
      const empty = document.querySelector('.arc__empty');
      if (empty) empty.hidden = [...groups].some((g) => !g.hidden);
    });
  });

  const arc = document.querySelector('[data-archive]');
  document.querySelectorAll('.arc__toggle button').forEach((btn, _, all) => {
    btn.addEventListener('click', () => {
      all.forEach((b) => b.setAttribute('aria-pressed', 'false'));
      btn.setAttribute('aria-pressed', 'true');
      arc.classList.toggle('arc--grid', btn.dataset.view === 'grid');
      if (btn.dataset.view === 'grid') {
        arc.querySelectorAll('.arc__thumb img[data-src]').forEach((img) => {
          img.src = img.dataset.src; img.removeAttribute('data-src');
        });
      }
      try { localStorage.setItem('antik-arc-view', btn.dataset.view); } catch (e) {}
    });
  });
  try {
    const saved = localStorage.getItem('antik-arc-view');
    if (saved === 'grid') document.querySelector('.arc__toggle [data-view="grid"]')?.click();
  } catch (e) {}

  const pf = document.querySelector('[data-product-form]');
  if (pf) {
    const variants = JSON.parse(pf.querySelector('[data-variants]').textContent);
    const selects = pf.querySelectorAll('select[data-option]');
    const idInput = pf.querySelector('input[name="id"]');
    const btn = pf.querySelector('button[type="submit"]');
    const price = document.querySelector('[data-price]');
    const update = () => {
      const chosen = [...selects].map((s) => s.value);
      const v = variants.find((v) => v.options.every((o, i) => o === chosen[i]));
      if (!v) { btn.disabled = true; btn.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      btn.disabled = !v.available;
      btn.textContent = v.available ? btn.dataset.add : btn.dataset.sold;
      if (price) price.innerHTML = v.price_html;
    };
    selects.forEach((s) => s.addEventListener('change', update));
  }
})();
